
import { defineComponent } from 'vue'
import WorkspaceTitle from '@/components/WorkspaceTitle.vue'
import KanbanList from '@/components/KanbanList.vue'
import KanbanBoardsList from '@/components/KanbanBoardsList.vue'
import { mapState } from 'vuex'

export default defineComponent({
  components: {
    WorkspaceTitle,
    KanbanList,
    KanbanBoardsList
  },
  data () {
    return {
      menuItems: [
        {
          icon: 'kanban',
          text: 'Boards',
          route: '/workspace'
        },
        {
          icon: 'person',
          text: 'Members',
          route: '/workspace'
        },
        {
          icon: 'gear',
          text: 'Settings',
          route: '/workspace'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      workspace: 'workspace'
    })
  }
})
